import * as z from 'zod';
import { CURRENCY } from 'src/types';
import { PAYMENT_TYPE } from 'src/features/payments/utils/types';

export type PaymentFormSchemaValues = z.infer<typeof paymentFormSchema>;
export const paymentFormSchema = z.object({
    date: z.string().nonempty(),
    currency: z.enum(CURRENCY),
    amount: z.number().int().min(0),
    type: z.enum(PAYMENT_TYPE),
    reference: z.string().optional().nullable(),
    customer: z.string().optional().nullable(),
    money_account: z.string().optional().nullable(),
});
